const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M4.25 5A.75.75 0 0 1 5 4.25h14a.75.75 0 0 1 0 1.5H5A.75.75 0 0 1 4.25 5m0 2.03A.75.75 0 0 1 5 6.28h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75M5 8.84a.75.75 0 1 0 0 1.5h14a.75.75 0 0 0 0-1.5zm-.75 4.37a.75.75 0 0 1 .75-.75h14a.75.75 0 1 1 0 1.5H5a.75.75 0 0 1-.75-.75M5 18.25a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5z"/></svg>';
export {
  a as w
};
